// extracted by mini-css-extract-plugin
export var fullHeightState = "_16-7";
export var headerCell = "_16-1";
export var loadingStateCell = "_16-4";
export var rowWrapper = "_16-3";
export var standaloneTable = "_16-8";
export var standaloneTableWithBodyFill = "_16-9";
export var stateCell = "_16-5";
export var table = "_16-0";
export var tableBodyFiller = "_16-6";
export var white = "_16-2";